import { render, staticRenderFns } from "./PopupNotification.vue?vue&type=template&id=4bcb8228&scoped=true"
import script from "./PopupNotification.vue?vue&type=script&lang=ts"
export * from "./PopupNotification.vue?vue&type=script&lang=ts"
import style0 from "./PopupNotification.vue?vue&type=style&index=0&id=4bcb8228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bcb8228",
  null
  
)

export default component.exports